
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import {
GetKeyValuesForSearch,
GetCommdotyListByQuery
} from "./../service/index";
export default {
name: "MultiSelect",
components: {
Group, XSwitch
},
props: {
pageNum: {
type: Number,
default: 0
},
pageSize:{
type: Number,
default: 10
},

bannerOid:{
type: String,
default: ''
},

MARA_MTART:{
type: String,
default: ''
},

byStock:{
type: Boolean,
default: true
},

kind:{
type: Number,
default: 0
},

SortType:{
type: Number,
default: null
},

default_FERTH:{
type: Array,
default: ()=>{
return []
}
},

SaleType:{
type: String,
default: ''
}
},
data() {
return {
isShow: false,





KeyWord: "", //关键字

ZZSZLFrom: null, //主石重从
ZZSZLTo: null, //主石重至
PriceFrom: null, //标签价从
PriceTo: null, //标签价至

categories: [], //品类
categories_cur: [],
categories_open: true,
series: [], //系列
series_cur: [],
series_open: false,
styles: [], //风格
styles_cur: [],
styles_open: false,

ZSZ: 0, // 1是 0否  证书要求（值为“双证”-点击则判断国际证书号有值的现货款式，不过滤到具体哪种类型证书。批次现货时才出现）

};
},
watch:{
pageNum(e){
console.log('------',e)
}
},
created() {


},
mounted() {


GetKeyValuesForSearch({MARA_MTART:this.MARA_MTART||''},(res)=>{

let data = JSON.parse(res.data)
this.categories = data.categories

if(this.default_FERTH.length>0){

this.series = this.default_FERTH
this.series_cur = [this.default_FERTH[0].code]
}else{
this.series = data.series
}
this.styles = data.styles
this.searchData()
})

},
methods: {

searchData(isSearch){
if(isSearch){
this.$emit('BackData',{},isSearch)
}
if(this.isLock) return
this.isLock = true

















let pData = {
'pageNum': isSearch ? 0 : this.pageNum,
'pageSize': this.pageSize,

'MARA_MTART': this.MARA_MTART,
'bannerOid': this.bannerOid,
'byStock': this.byStock,
'kind': this.kind,

'KeyWord': this.KeyWord,
'ZPM': this.categories_cur, //品类
'FERTH': this.series_cur, //系列
'ZFG': this.styles_cur, //风格
'ZZSZLFrom': this.ZZSZLFrom,
'ZZSZLTo': this.ZZSZLTo,
'PriceFrom': this.PriceFrom,
'PriceTo': this.PriceTo,
'ZSZ': this.ZSZ, //是否双证

'SortType': this.SortType
}

if(this.SaleType) pData.SaleType = this.SaleType;

console.log('==请求参数==',pData)


GetCommdotyListByQuery(pData,(res)=>{
this.$emit('BackData',res)
this.isLock = false
this.isShow = false;
this.OpenCover()
})

},

Reset(){
this.categories_cur = []
this.series_cur = this.default_FERTH.length>0?[this.default_FERTH[0].code]:[]
this.styles_cur = []
this.ZZSZLFrom = null
this.ZZSZLTo = null
this.PriceFrom = null
this.PriceTo = null
this.ZSZ = 0
},

DoSlide() {
this.isShow = !this.isShow;
this.OpenCover()
},
OpenCover(){
if(this.isShow){
document.documentElement.style.overflow = 'hidden' 
document.documentElement.style.height = '100vh' 
document.body.style.overflow = 'hidden'
document.body.style.height = '100vh'
}else{
document.documentElement.style.overflow = 'auto' 
document.documentElement.style.height = 'auto' 
document.body.style.overflow = 'auto' 
document.body.style.height = 'auto' 
}
},

CheckFun(item,key,diabled){
if(diabled) return
let index = this[key+'_cur'].indexOf(item.code)
if(index == -1 ){
this[key+'_cur'] = [...this[key+'_cur'],item.code]
}else{
this[key+'_cur'].splice(index,1)
}
console.log(key+'_cur：',this[key+'_cur'])
},

},
};



// WEBPACK FOOTER //
// ./src/components/MultiSelect.vue